import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=69278f0d&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"
import style0 from "./index copy.vue?vue&type=style&index=0&id=69278f0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69278f0d",
  null
  
)

export default component.exports